import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { IncidenceChangeItem } from 'modules/payroll_bundle/lib/types'

interface Props {
  change: IncidenceChangeItem
}

const IncidenceSupplementsItem = ({ change }: Props) => {
  return (
    <>
      <Text.Normal size="300" weight="medium">
        {i18n.t('bookkeepers.incidence.details.additional_supplement')}
      </Text.Normal>
      <Box
        background="grey200"
        paddingY="s16"
        paddingX="s24"
        borderRadius={{ all: 'abs008' }}
        gap="s16"
      >
        <Text.Normal size="300" weight="medium" overflowWrap color="grey1000">
          {change.currentValue?.taxonomyName}
        </Text.Normal>
        <Box gap="s8">
          <Text.Normal weight="semibold" size="200">
            {i18n.t('bookkeepers.additional_supplement.labels.amount')}
          </Text.Normal>
          <Text.Normal size="200">{change.currentValue?.amount}</Text.Normal>
        </Box>
        <Box gap="s8">
          <Text.Normal weight="semibold" size="200">
            {i18n.t('bookkeepers.additional_supplement.labels.observation')}
          </Text.Normal>
          <Text.Normal size="200">{change.currentValue?.observation}</Text.Normal>
        </Box>
      </Box>
    </>
  )
}
export default IncidenceSupplementsItem
